// extracted by mini-css-extract-plugin
export default {"error":"Error404_error__GSPax"};